// Price calculations + helpers shared across admin pages
// IMPORTANT: All %-based fields (marg/markup/commission) use MARGIN semantics (gross-up by /(1-x)),
// NOT additive mark-up. Bank is an additive financial cost on top of acq.
// Only `discount` is a true price reduction (mark-down).
export const calculateBasePrice = (acq, bank, marg, extra) => {
  if (acq <= 0) return 0;
  // base = (acq / (1 - marg)) + (acq * bank) + extra
  const margFactor = marg < 1 ? 1 - marg : 0.001;
  return Math.round((acq / margFactor + acq * bank + extra) * 100) / 100;
};

export const calculateFinalPrice = (basePrice, commission, markup, discount = 0) => {
  if (basePrice <= 0) return 0;
  let price = basePrice;
  if (markup > 0 && markup < 1)        price = price / (1 - markup);
  if (commission > 0 && commission < 1) price = price / (1 - commission);
  if (discount > 0 && discount < 1)    price = price * (1 - discount);
  return Math.round(price * 100) / 100;
};

export const getWeekNumber = () => {
  const d = new Date();
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const dayNum = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  return Math.ceil((((date - yearStart) / 86400000) + 1) / 7);
};

export const getLocalizedName = (item, lang) => {
  if (lang === "en" && item?.name_en) return item.name_en;
  return item?.name || "";
};

export const getLocalizedDesc = (item, lang) => {
  if (lang === "en" && item?.description_en) return item.description_en;
  return item?.description || "";
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
